import { getMenu } from './elements/catalog-menu.js';
import {
    getCarList,
    updateCarList,
    updateCarStortage,
} from './elements/car-list.js';
import { clearStorage } from './elements/clear-storage.js';
import { getLocaleSetings } from './elements/locale.js';
import { cookies } from './elements/cookies.js';
import {
    eventsSender,
    eventsSenderYandex,
    getIds,
    eventsSenderWithPerfomance,
    eventsSenderBackend,
    amplitudeEventsInstance,
} from './elements/events-sender.js';
import { getKey } from './elements/code.js';
import { helpers } from './helpers/helpers.js';
import { addCarByNumber, addCarByVin } from './elements/car-data.js';
import eventBus from './eventBus/index.js';
import * as http from './elements/http.js';
import { sendError } from './elements/error-sender.ts';
import { retailMedia } from './elements/retail-media/retail-media.js';

let globalState = {
    getConfig() {
        return window.config;
    },
    getMenu,
    getCarList,
    updateCarList,
    updateCarStortage,
    clearStorage,
    cookies,
    eventsSender,
    eventsSenderYandex,
    getIds,
    helpers,
    addCarByNumber,
    addCarByVin,
    isMobile: window?.config?.state?.theme === 'mobile',
    sendError,
    retailMedia,
};

export {
    globalState,
    cookies,
    getLocaleSetings,
    eventsSender,
    eventsSenderWithPerfomance,
    eventsSenderBackend,
    eventsSenderYandex,
    amplitudeEventsInstance,
    getKey,
    helpers,
    getIds,
    addCarByNumber,
    addCarByVin,
    eventBus,
    http,
    sendError,
    retailMedia,
};
